import { hidePopup, showPopup } from './modules/controls';
import { selectors } from './modules/lib';

/**
 * Add event listeners
 */
document.querySelectorAll(selectors.popupContainer).forEach((popup) => {
	const ref = popup.getAttribute('data-popup-ref') ?? '';

	document.querySelectorAll(`[data-open-popup="${ref}"]`).forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			e.preventDefault();
			showPopup(ref);

			// Stop propagation to prevent window click listener to trigger
			e.stopPropagation();
		});
	});

	// Video handling
	popup.addEventListener('click', (e) => {
		// Stop propagation if popup does not contain any video
		// (propagation will be stopped later to enable later click events)
		if (!popup.querySelector(selectors.youTubeContainer)) {
			e.stopPropagation();
		}
	});
});

document.querySelectorAll(selectors.popupClose).forEach((close) => {
	close.addEventListener('click', hidePopup);
});

window.addEventListener('keydown', (event: KeyboardEvent) => {
	if (event.key === 'Escape') {
		hidePopup();
	}
});

window.addEventListener('showPopup', (event) => {
	if (!(event instanceof CustomEvent)) return;
	showPopup(event.detail);
});

// hide popup on click outside
window.addEventListener('click', (event) => {
	const target = event.target;
	if (!(target instanceof Element)) return;

	const popup = document.querySelector(selectors.popupContainer);

	const isInPopup = popup && popup.contains(target);
	const isDatepicker = target.closest('.ui-datepicker'); // Datepicker
	const isYoutube = target.classList.contains('youtube'); // Youtube Video
	// cspell:disable-next-line
	const isBorlabs = target.classList.contains('brlbs-cmpnt-cb-btn'); // Borlabs Cookie Button

	if (isInPopup || isDatepicker || isYoutube || isBorlabs) {
		return;
	}

	hidePopup();
});
